<template>
  <AddressForm mode="create" />
</template>

<script>
import AddressForm from "@/components/page-components/Account/Address/AddressForm.vue";

export default {
  components: {
    AddressForm,
  },
}
</script>

<style scoped>

</style>
